module.exports = __webpack_public_path__ + "static/media/Dubai-Police.ee3229b7.jpg";